import {getRouteApi} from "@tanstack/react-router";

export const usersRouteApi = getRouteApi("/_app/user-management/users/");

export type UsersNavigateFn = ReturnType<typeof usersRouteApi.useNavigate>;
